// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerDiscoveryReview_Page__1mpeN"};